import React from 'react';
import { c as classnames } from '../../index-2586sEvh.js';
import CircularProgress from '../CircularProgress/index.js';
import Link from '../Link/index.js';
import '../../_commonjsHelpers-jjO7Zipk.js';
import 'next/link';

const ToolTip = ({ children, variant = 'info', position = 'bottom', }) => (React.createElement("span", { className: `tool-tip ${variant}-ui ${position}` },
    React.createElement("span", null, children)));

/**
 * Basic button component
 */
const Button = ({ children, type = 'button', variant = 'main', ariaLabel, href, target, id, className = '', isLoading = false, loadingMsg = '', disabled = false, disabledMsg = '', buttonRef = null, noTabbing = false, ariaHidden = false, toolTipVariant, tooltipPosition, onClick, ...rest }) => {
    if (href) {
        return (React.createElement(Link, { href: href, "data-testid": className, className: classnames(`btn-${variant} ${className}`), "aria-label": ariaLabel, target: target, tabIndex: noTabbing ? -1 : undefined, id: id, onClick: onClick, noClass: true, ...rest },
            React.createElement("span", null, !!children && children)));
    }
    return (React.createElement("button", { 
        // eslint-disable-next-line react/button-has-type
        type: type, id: id, ref: buttonRef, className: classnames(`${variant === 'none' ? 'btn' : `btn-${variant}`} ${className} ${isLoading ? 'loading' : ''}`), "aria-label": ariaLabel, "data-testid": className.split(' ')[0], disabled: disabled, "aria-disabled": disabled, tabIndex: noTabbing ? -1 : undefined, ...(ariaHidden && { 'aria-hidden': true }), onClick: onClick, ...rest },
        React.createElement("span", null, children),
        isLoading && (React.createElement(React.Fragment, null,
            React.createElement(CircularProgress, { size: 20 }),
            React.createElement("div", { role: "alert", className: "sr-only" }, loadingMsg))),
        disabledMsg && (React.createElement(ToolTip, { variant: toolTipVariant, position: tooltipPosition }, disabledMsg))));
};

export { Button as default };
//# sourceMappingURL=index.js.map
